import { HTMLAttributes } from 'react';
import { TableRow } from '@e2n/ui';

export function E2NtableRow({
  children,
  ...other
}: HTMLAttributes<HTMLTableRowElement>) {
  return <TableRow {...other}>{children}</TableRow>;
}
